// extracted by css-extract-rspack-plugin
export default {"triggerLabel":"triggerLabel-HVM6mt"};